export enum WorkflowOperationType {
    CREATE = 'create',
    UPDATE = 'update'
}
